import { collection, query, getDocs } from 'firebase/firestore';
import { db } from './../firebase';
import 'jspdf-autotable';

export const ExportJSON = async () => {
  const users = await getDocs(query(collection(db, 'users')));
  const userData = [];
  users.forEach((user) => {
    //prettier-ignore
    userData.push(user.data());
  });

  //ExportJSON
  const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(userData, null, 2));
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', 'backup_users_' + new Date().toISOString().slice(0, 10) + '.json');

  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};
